import Navigation from './navigation';

var __participantTDA = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';

var gxpPlugin = Navigation.Plugin.extend({
  onRendered: function () {
    if (__participantTDA) {
      $('.site-nav-utility').append('<li style="height: 30px;"><div id="dg-component-nav-menu-desktop"></div></li>');
      $('.site-nav-mobile-top-bar').children('.site-nav-zip').css('flex', '0');
      $('<div class="site-nav-gxp"><div id="dg-component-nav-menu-mobile"></div>').insertAfter('.site-nav-mobile-top-bar .site-nav-zip');
      const siteNavGxp = document.querySelector("#dg-component-nav-menu-mobile");
      if(siteNavGxp.childNodes.length == 0) {
        $('.site-nav-gxp').css('border-left-color', 'transparent');
      }
    }
  }
});

Navigation.registerPlugin(gxpPlugin);
